import { render, staticRenderFns } from "./LanguageSelectWidget.vue?vue&type=template&id=1675251e&scoped=true&lang=pug&"
import script from "./LanguageSelectWidget.vue?vue&type=script&lang=js&"
export * from "./LanguageSelectWidget.vue?vue&type=script&lang=js&"
import style0 from "./LanguageSelectWidget.vue?vue&type=style&index=0&id=1675251e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1675251e",
  null
  
)

export default component.exports